import React, { useState, useEffect }  from 'react';
import HeroSection from '../sections/heroSection';
import PortfolioDetail from '../components/portfolio-details';
import Close from '../svgs/close.js';
import View from '../svgs/view.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import '../styles/sections/portfolio.scss';


const content = {
    "heroSection":{
        "enable": true,
        "title":"Portfolio",
        "subtext":"<strong>Crafted With Love<br/> Built With Passion</strong>",
        "image": require('../images/portfolios/banner.png'),
        "mobileImage": require('../images/portfolios/banner_mobile.png'),
        "class": "move-from-right"
    }
};


function Portfolio(props){ 
    const html = document.getElementsByTagName('html')[0];
    const allPortfolios = require('../jsons/portfolios.js').default;
    //Add a class to body
    const body = document.body;
    body.classList = 'template-portfolio';

    const [modal, openModal] = useState('');
    const [data, setData] = useState({});
    const [portfolios, setPortfolios] = useState(allPortfolios);    
    
    function toggleDetails(details){
        openModal('active');
        setData(details);
        html.classList.add('popup-active');
    }

    function closeDetails(){
        openModal('');
        setData('');
        html.classList.remove('popup-active');
    }

    const filtering = () => {
        console.log('ddd');
        const filters = document.getElementsByClassName('portfolio-filter')[0].children;
        for(var i = 0; i < filters.length; i++){            
            filters[i].addEventListener('click', function(e){
                for(var i = 0; i < filters.length; i++){
                    filters[i].classList.remove('active');    
                }
                this.classList.add('active');
                portFolioFilters(this.textContent);              
            })
        }
    }

    const portFolioFilters = (filterTitle) => {        
        if(filterTitle === 'All'){            
            setPortfolios(allPortfolios);
        }else{
            var filterePortfolio = allPortfolios.filter(function(portfolio){
                return (portfolio.catg.indexOf(filterTitle) >= 0);
            });
            setPortfolios(filterePortfolio);
        }
    }

    useEffect(() => {
        filtering();        
    });
    
    return (
        <div className="innerWrapper lightGrayeaBg">
            {content.heroSection.enable && 
                <HeroSection data={ content.heroSection }/>
            }     
            <div className="portfolio-inner innerBox lg whiteBg"> 
                <ul className="portfolio-filter">
                    <li className="active">All</li>
                    <li>Apps</li>
                    <li>Web</li>
                    {/* <li>Shopify</li> */}
                    <li>Ecom</li>
                    <li>Educational</li>
                    <li>Fintech</li>
                    <li>Healthcare</li>
                </ul>
                {portfolios.length > 1 ? 
                    <div className="pf-grid">
                        {portfolios.map((d, i) =>
                            <div key={i} onClick={() => toggleDetails(d)}> 
                                <LazyLoadImage
                                    alt={d.title}
                                    className="slide-up"
                                    effect="blur"
                                    src={d.gridImg} // use normal <img> attributes as props
                                />
                                <span className="view"><View /></span>
                            </div>                         
                        )}
                    </div>
                : <div className="tac">No Portfolios Found</div>
                }                
                <div className={`portfolio-detail ${modal}`}>
                    <div className="inner-wrap whiteBg">
                        <span className="close" onClick={closeDetails}><Close /></span>
                        { modal && 
                            <PortfolioDetail data={data}  />
                        }   
                    </div>
                </div>          
            </div>
        </div>
    );
};

export default Portfolio;